import {
  type ListShippingReceiptResponse,
  type ListShippingResponse
} from '@/services/WarrantyApiService/types'
import WarrantyApiService from '@/services/WarrantyApiService/WarrantyApiService'
import { useQuery } from '@tanstack/vue-query'
import type { Ref } from 'vue'

export function fetchShippingQuery() {
  return useQuery<ListShippingResponse, Error>({
    queryKey: ['list-shipping'],
    queryFn: async () => {
      const response = await WarrantyApiService.listShipping()

      if (response.isWrong()) {
        const error = new Error(response.value.message)
        error.name = response.value.name
        throw error
      }

      return response.value
    },
    retry: false
  })
}

export function fetchShippingReceiptsQuery(shippingId: Ref<string | null>) {
  return useQuery<ListShippingReceiptResponse, Error>({
    queryKey: ['list-shipping-receipt', shippingId],
    queryFn: async () => {
      const response = await WarrantyApiService.listShippingReceipt(shippingId.value!)

      if (response.isWrong()) {
        const error = new Error(response.value.message)
        error.name = response.value.name
        throw error
      }

      return response.value
    },
    retry: false,
    enabled: () => !!shippingId.value
  })
}

export function fetchAttestToShippingVerification(
  shippingId: Ref<string | null>,
) {
  return useQuery<void, Error>({
    queryKey: ['attest-to-shipping-verification'],
    queryFn: async () => {
      if (!shippingId.value) {
        throw new Error('ShippingId is required')
      }

      const response = await WarrantyApiService.attestToShippingVerification({
        id: shippingId.value
      })

      if (response.isWrong()) {
        const error = new Error(response.value.message)
        error.name = response.value.name
        throw error
      }

      return undefined
    },
    retry: false,
    enabled: false
  })
}
